<template>
    <div class="row mx-0 pt-3">
        <loader v-if="pageLoader"></loader>
        <div class="col-lg-12 col-md-13 col-sm-12 mb-3" v-if="!pageLoader && Object.keys(checkObtCall).length > 0  && checkObtCall.obtCallInfo.length > 0 && checkObtCall.obtCallDoneWithObt.length > 0"><!--  -->
            <div class="alert alert-danger" role="alert" v-if="getError">{{getError}}</div>
            <div class="bg-white border-radius-5 p-4 chooseAppointment">
                <div class="row no-gutters align-items-center step1Appointment" v-if="step == 1">
                    <div class="col-md-4">
                        <div class="appointment-type mb-3">
                            <h3>Select your appointments type</h3>
                            <p>Routine medical examination can help you identify any early signs of health issues</p>
                        </div>
                        <ul class="selectSummery  "><!--  v-if="select_appointment_type != 2" -->
                            <li class="mb-3 d-flex align-items-center justify-content-between" v-for="value,key,index in $env_var.appointmentTypeJson" :class="[{'active':appoint_type == key}]" @click="appoint_type = key">
                                <div class="areaSummery d-flex align-items-center">
                                    <div class="inIcon mr-3">
                                        <!-- <img :src="'../../../../static/website/images/'+(index == 0?'pedestrian':'booking')+'.svg'" alt="Image"> -->
                                        <span class="maskImage" :class="index == 0?'img-1':'img-2'"></span>
                                    </div>
                                    <label class="checkbox p-0">{{value}}
                                        <input type="radio" id="walk-in" name="appointment type" :value="key" v-model="appoint_type" v-validate="'required'"> 
                                         <!-- <span class="checkmark"></span>  -->
                                    </label>
                                </div>
                                <button class="select-button align-items-center justify-content-center" v-show="appoint_type == key">
                                    <!-- <span class="mr-2">Selected</span>  -->
                                    <feather type="check"></feather>
                                </button>
                            </li>
                        </ul>
                        <div v-if="submitted && errors.has('appointment type')" class="alert alert-danger" role="alert"><p class="error mb-0" >{{ errors.first('appointment type') }}</p></div>
                        <div class="mt-4 button-bottom d-flex" @click="bookAppointment()">
                            <a href="javascript:void(0)" class="btn btn-blue save" :class="[{'disabled':!appoint_type}]">Book Appointment</a>
                        </div>
                    </div>
                    <!-- <div class="col-md-8 pl-3">
                        
                    </div> -->
                </div>
                <div class="step2Booking" v-else-if="step == 2">
                    <div class="row mb-4">
                        <div class="col-12 ">
                            <div class="border-bottom mb-3 pb-3 Title-Area">
                                <h3 class="mb-0">Our Best Doctors</h3>
                            </div>
                        </div>
                        <div class="col-md-4 pr-3">
                            <div class="d-flex border p-3 border-radius-5 align-items-center">
                                <figure class="profli-pic mb-0 mr-3"><img src="../../../../static/website/images/DrAnilBhansali.png" alt="" /></figure>
                                <div class="doctorInfo">
                                    <h6 class="mb-0">Dr. Anil Bhansali<!-- {{( (doc_data.firstname || '') + ' ' + (doc_data.lastname || '') ).trim() || '-'}} --></h6>
                                    <p class="mb-0">Former HOD Endocrinology - PGI</p>
                                    <p class="mb-0">MD, DM, FRCP</p>
                                    <ul class="d-flex mb-0 list-fav">
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 pr-3">
                            <div class="d-flex border p-3 border-radius-5 align-items-center">
                                <figure class="profli-pic mb-0 mr-3"><img src="../../../../static/website/images/DrPuneetVerma.png" alt="" /></figure>
                                <div class="doctorInfo">
                                    <h6 class="mb-0">Dr. Puneet Verma</h6>
                                    <p class="mb-0">MBBS, MD, DNB, DM</p>
                                    <ul class="d-flex mb-0 list-fav">
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 pr-3">
                            <div class="d-flex border p-3 border-radius-5 align-items-center">
                                <figure class="profli-pic mb-0 mr-3"><img src="../../../../static/website/images/DrShabnamKarDas.png" alt="" /></figure>
                                <div class="doctorInfo">
                                    <h6 class="mb-0">Dr. Shabnam Kar Das</h6>
                                    <p class="mb-0">MD, FMNM</p>
                                    <ul class="d-flex mb-0 list-fav">
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                        <li><a href="#"><feather type="star"></feather></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-12 ">
                            <div class="border-bottom mb-3 pb-3 Title-Area">
                                <h3 class="mb-0">Select Date </h3>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row mb-4">
                                <div class="col-md-6">
                                    <div class="form-group selectAppointment">
                                        <datepicker v-model="select_date" :lang="lang" :editable="false"  :open="true" :shortcuts= "[]" placeholder="Select appointment date" name="appointment date" format="DD-MM-YYYY" ref="startDateInput" @input="busyListCall()" :disabled-days="disabledDates" v-validate="'required'"></datepicker>
                                        <p class="error" v-if="submitted" v-for="error in errors.collect('appointment date')">{{ error }}</p>
                                        <!-- <FullCalendar :options="calendarOptions"  id="calendar" ref="fullCalendar"/> -->
                                    </div>
                                </div>
                                <div class="col-12" v-if="diseaseList.length > 0">
                                    <p>What do you need help with?</p>
                                    <div class="form-group d-flex flex-wrap needHelp">
                                        <label class="checkbox" v-for="item,key in diseaseList" :for="'medical_'+key">{{item.name}}
                                            <input type="checkbox" :id="'medical_'+key" :value="parseInt(item.id)" v-model="medical" name="medical" v-validate="'required'">
                                            <span class="checkmark"></span>
                                        </label>
                                        <span class="text-danger" v-if="submitted && errors.has('medical')">Field is required</span>
                                    </div>
                                    <div class="form-group" v-if="medical.includes(151)">
                                        <!-- <label for="uname">Phone Number</label> -->
                                        <div class="position-relative inputIcon">
                                            <input type="text" placeholder="Others..." name="other_condition" v-model="other_condition" class="form-control pr-5" v-validate="'required'">
                                        </div>
                                        <span class="text-danger" v-if="submitted && errors.has('other_condition')">field is required</span>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <div class="form-group selectAppointment">
                                        <div class="position-relative">
                                            <input placeholder="Remarks" type="text" v-model="remarks" name="remarks" class="float-field form-control" ref="enquiryInput" />
                                        </div>
                                            
                                    </div>
                                </div> -->
                            </div>
                            <div class="row ">
                                <div class="col-12 ">
                                    <div class="border-bottom mb-3 pb-3 Title-Area">
                                        <h3 class="mb-0" v-if="select_date">Select Time</h3>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <input type="hidden" name="slot" v-model="avaiable_slots" v-validate="'required'">
                                    <!-- <h6 v-if="select_date">{{select_date | moment('MMMM Do YYYY')}}</h6> -->
                                    <div class="alert alert-warning mb-3" role="alert"  v-if="checkBooked">
                                        <!-- --{{patientBusySlot}}-- -->
                                        Appointment allready booked of {{select_date | moment('MMMM Do YYYY')}}
                                    </div>
                                    <ul class="select-book d-flex align-items-center flex-wrap" v-else-if="slotFilter(totalSlotList).length > 0">
                                        <li class="mb-3" v-for="list in slotFilter(totalSlotList)" :class="[{'disabled':busySlotList.includes(list.slot),'booked active':avaiable_slots == list.id}]">
                                            <a href="javascript:void(0)" @click="setSlot(list)">{{formatSlot(list.slot)}}
                                                <span class="list-Circle" v-if="avaiable_slots == list.id"><feather type="check"></feather></span>
                                            </a>
                                        </li>
                                        <!-- <li class="booked mb-3"><a href="#">4:00 PM</a></li>
                                        <li class="mb-3"><a href="#">4:30 PM</a></li> -->
                                    </ul>
                                    <span v-else><!--   -->
                                        No Slot available for {{select_date | moment('MMMM Do YYYY')}}
                                    </span>
                                    <p class="error" v-if="submitted" v-for="error in errors.collect('slot')">{{ error }}</p>
                                </div>
                            </div>
                            <!-- <div class="error-massge text-center mt-5 border-radius-10">
                                <p>You have already a appointment on this day</p>
                            </div> -->
                            
                        </div>
                        <div class="d-flex align-items-center col-12">
                            <div class="button-bottom d-flex justify-content-center mr-2" @click="step = 1"><a href="javascript:void(0)" class="btn btn-red save">Back</a></div>
                            <div class=" button-bottom d-flex justify-content-center ml-2" @click="bookAppointment()"><a href="javascript:void(0)" class="btn btn-blue save">Confirm Appointment</a></div>
                        </div>
                    </div>
                </div>
                <div class="row no-gutters justify-content-center" v-else-if="step == 3">
                    <div class="col-md-5 text-center check-consultion mb-3">
                        <figure ><img src="../../../../static/website/images/appointment-calendar.svg" alt=""></figure>
                        <h2 class="theme-color">Congratulations</h2>
                        <p> Your next appointment is {{appontmentTime()}}.  </p>
                        <!-- <h6>online meeting here:<a href="https://www.client.ginihealth.com/consult">https://www.client.ginihealth.com/consult</a></h6> -->
                        <!--<div class="text-center chek-bg border-radius-5 mt-3 mb-4">
                           <p>Please Fill the intake Questionnaire Form to get dedicated assistance in your Health Journey</p>
                          <router-link to="/appointment-list" class="text-center back">Back to Appointments</router-link>
                          
                        </div> -->
                        <router-link to="/appointment-list" class="btn btn-blue Assessment">View Appointments</router-link>
                    </div>
                </div>
            </div>
        </div>
        <obt-call v-if="!pageLoader && Object.keys(checkObtCall).length > 0 && checkObtCall.obtCallDoneWithObt.length == 0"></obt-call>
    </div>
</template>
<script>
    import FullCalendar, { CalendarApi } from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import interactionPlugin from '@fullcalendar/interaction'
    import obtcall from '../obtCall/obt-call'

    import moment from 'moment'
    export default {
        name: 'Book-Appointment',
        data() {
            return {
                pageLoader: false,
                submitted: false,
                lang: 'en',
                doctor_id : 49,
                appoint_type : '',
                select_date: '',//moment().format('YYYY-MM-DD')
                select_date_old: '',//moment().format('YYYY-MM-DD')
                avaiable_slots : '',
                getTime : '',
                remarks : '',
                step: 1,
                doc_data:{},
                getError: '',
                medical : [],
                other_condition : '',
                // disabledDates: {
                //   to: new Date(Date.now() - 8640000)
                // },
                calendarOptions: {
                    plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
                    initialView: 'dayGridMonth', //  'timeGridDay',timeGridWeek
                    dateClick: this.handleDateClick,
                    eventClick: this.eventClicked,
                    // weekends: false,
                    headerToolbar: {
                        left:   'prev,next today',//prev,next today
                        center: '',//title
                        right:  'title'//dayGridMonth,timeGridDay
                    },
                    editable: true,
                    validRange :{start: moment().format('YYYY-MM-DD')},
                    //selectable: true,
                    selectMirror: true,
                    dayMaxEvents: true,
                    events: [],

                }

            }
        },
        components: {
            FullCalendar,
            obtCall : obtcall
        },
        methods: {
            appontmentTime(){
                let date = new Date(this.select_date)
                date.setHours(this.getTime.split('.')[0])
                date.setMinutes(this.getTime.split('.')[1])
                return moment(date).calendar();
            },
            printError(val){
                this.getError = val
                let _that = this
                setTimeout(()=>{
                    _that.getError = ''
                }, 5000);
            },
            slotFilter(list){
                list = list || [];
                let _that = this
                return list.filter(val=> val.slot && !_that.busySlotList.includes(val.slot) && _that.allowdate(val.slot))
            },
            handleDateClick(arg){
                // console.log('===arg',arg)
                // alert(arg.dateStr)
                this.select_date = arg.dateStr
                this.busyListCall()
            },
            setSlot(list){
                if(!this.busySlotList.includes(list.slot)){
                    this.avaiable_slots = list.id
                    this.getTime = list.slot
                }
            },
            dateFarmat(val){
                return moment().format('MMMM Do YYYY')
            },
            formatSlot(val){
                let date = new Date()
                date.setHours(val.split('.')[0])
                date.setMinutes(val.split('.')[1])
                return moment(date).format('h:mm a')
            },
            allowdate(val){
                if(this.select_date){
                    let date = new Date(this.select_date)
                    date.setHours(val.split('.')[0])
                    date.setMinutes(val.split('.')[1])
                    return moment(date).diff(moment(), 'minutes') >= 0
                }else{ return true }
            },
            disabledDates(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return date < today|| moment(date).day() == 0// || moment(date).day() == 6  
            },
            availableListCall() {
                this._runGetAvailableSlotsList({'globalParams' : {}, 'localParams' :{'parameter' : this}})
            },
            busyListCall() {
                if(this.select_date){
                    var day = new Date(this.select_date).getDay();
                    if([0].includes(day)){//,6
                        this.select_date = this.select_date_old
                        alert('Weekends not allowed');
                        return
                    }
                    this.select_date_old = this.select_date
                    let input_json = {
                        'globalParams' : {
                            "doctor_id": this.doctor_id,
                            "appointment_date": moment(this.select_date).format('YYYY-MM-DD')
                        },
                        'localParams' :{'parameter' : this}
                    }
                    this._runGetBusySlotList(input_json)
                    this.callBusyDay()
                }
                this.avaiable_slots = ""
                this.getTime = ""
            },
            callBusyDay(){
                var month = new Date(this.select_date).getMonth()+1;
                var year = new Date(this.select_date).getFullYear();
                let isAvailable = false
                this.patientBusySlot.forEach(val=>{
                    if(month == new Date(val).getMonth()+1 && year ==  new Date(val).getFullYear()){
                        isAvailable = true
                    }
                })
                if(!isAvailable){
                    this._runGetPatientBusySlot({ 'globalParams' : { "doctor_id": this.doctor_id,"month":month },'localParams' :{'parameter' : this}})
                }
            },
            bookAppointment() {
                if(!this.appoint_type){
                    return
                }
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        if(_that.step == 1){
                            _that.step = 2
                            let input_json = {
                                'globalParams' : {
                                    "admin_id": _that.doctor_id,
                                },
                                'localParams' :{'parameter' : this}
                            }
                            _that._runGetDoctorDetails(input_json)
                            // _that.busyListCall()
                        }else{
                            var day = new Date(this.select_date).getDay();
                            if([0].includes(day)){//,6
                                this.select_date = this.select_date_old
                                alert('Weekends not allowed');
                                return
                            }
                            let date = new Date()
                            date.setHours(this.getTime.split('.')[0])
                            date.setMinutes(this.getTime.split('.')[1])
                            let start_time = moment(date).format('HH:mm')
                            let end_time = moment(date).add(30,'minutes').format('HH:mm')
                            let json = {}
                            if(_that.medical.length > 0){
                                _that.medical.forEach(item =>{
                                    _that.diseaseList.forEach(val =>{
                                        if(val.id == item){
                                            if(parseInt(item) == 151){
                                                json[item] = _that.other_condition
                                            }else{
                                                json[item] = val.name
                                            }
                                        }
                                    })
                                })
                            }
                            let input_json = {
                                'globalParams' : {
                                    "doctor_id": _that.doctor_id,
                                    "doc_name": ( (_that.doc_data.firstname || '') + ' ' + (_that.doc_data.lastname || '') ).trim() || '',
                                    "enquiry": json,
                                    "appointment_date": moment(_that.select_date).format('YYYY-MM-DD'),
                                    "start_time": start_time,
                                    "end_time": end_time,
                                    "slot_id": _that.avaiable_slots,
                                    "appoint_type": _that.appoint_type
                                },
                                'localParams' :{'parameter' : this}
                            }
                            this._runAddAppointment(input_json)
                        }
                    }
                });
            },
            formatTime(startTime,endTime){
                let start = '',startSplit = '', end = '', endSplit = ''
                start =  moment(startTime ,["h:mm:ss A"])
                startSplit =  moment(start).format("HH:mm")
                end =  moment(endTime ,["h:mm:ss A"])
                endSplit =  moment(end).format("HH:mm")
                return startSplit+'-'+endSplit
            },
            CheckObtCallStatus(){
                this._runCheckObtCall({'globalParams': {},'localParams': {"parameter": this}})
            }
        },
        computed:{
            checkBooked(){
                try{
                    if(this.select_date != '' && this.patientBusySlot.length > 0){
                        let returnType = false
                        this.patientBusySlot.forEach(val=>{
                            // console.log(val,moment(this.select_date),moment(val),moment(this.select_date).isSame(moment(val), 'day') )
                            if(moment(this.select_date).isSame(moment(val), 'day')){
                                returnType = true
                            }
                        })
                        return returnType
                    }else{ return false; }
                }catch(e){ return false; }
            }
        },
        mounted() {
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.filter-dropdown').length){
                    // _that.setToggle = false
                    // _that.setStatus = false
                    // _that.setStatusfilter = false
                }
            });
            // scrool table
            // $( window ).resize(function() {
            //     var elem = $('#tableList');
            //     if(elem.scrollLeft() == 0){
            //         _that.tableScroll =false
            //     }else { _that.tableScroll = true }
            // })
            // if($('#tableList')[0].scrollWidth-2 <= $('#tableList').outerWidth()){
            //     _that.tableScroll =false
            // }
            // $('#tableList').on('scroll', (e)=>{
            //     var elem = $(e.currentTarget);
            //     if(elem.scrollLeft() == 0){
            //         _that.tableScroll =false
            //     }else { _that.tableScroll = true }
            // });
        },
        created(){
            this.pageName('Book-Appointment')
            this.availableListCall()
            if(this.diseaseList.length == 0){
                this._rungetRegisterDiseaseList({'globalParams': {},'localParams': {"parameter": this}})
            }
            this.CheckObtCallStatus()
        }
    }
</script>
<style>
/*@import '@fullcalendar/core/main.css';*/
@import '@fullcalendar/daygrid/main.css';
</style>



// WEBPACK FOOTER //
// src/components/website/appointments/book-appointment.vue